export const GLOBAL_STATE = 'MobileSettings' as const
export const MOBILE_SETTINGS = 'MOBILE_SETTINGS' as const
export const MOBILE_SETTINGS_VERSIONS = 'MOBILE_SETTINGS_VERSIONS' as const
